import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import '../utils/load-imags.util'

// Layout
import MainLayout from "@/views/layout/main/MainLayout.vue";
import AuthLayout from "@/views/layout/auth/AuthLayout.vue";

// Pages
const LoginPage = () => import('@/views/pages/auth-pages/login/Login.vue')
const RegisterPage = () => import('@/views/pages/auth-pages/register/Register.vue')
const ForgotPasswordPage = () => import('@/views/pages/auth-pages/forgot-password/ForgotPassword.vue')
const ChangePasswordPage = () => import('@/views/pages/auth-pages/change-password/ChangePassword.vue')
const ResetPasswordSuccessPage = () => import('@/views/pages/auth-pages/reset-password-success/ResetPasswordSuccess.vue')

const TutorialPage = () => import('@/views/pages/auth-pages/tutorial/Tutorial.vue')
const TutorialStartPage = () => import('@/views/pages/auth-pages/tutorial/tutorial-start/TutorialStart.vue')
const TutorialFinishPage = () => import('@/views/pages/auth-pages/tutorial/tutorial-finish/TutorialFinish.vue')
const HomePage = () => import('@/views/pages/main-pages/home/Home.vue')
const SearchInputPage = () => import('@/views/pages/main-pages/search/search-input/SearchInput.vue')
const SearchResultPage = () => import('@/views/pages/main-pages/search/search-result/SearchResult.vue')
const GrowTreePage = () => import('@/views/pages/main-pages/grow-tree/GrowTree.vue')
const AlbumPage = () => import('@/views/pages/main-pages/album/Album.vue')
// const SettingPage = () => import('@/views/pages/main-pages/setting/Setting.vue')
const AddNewBaby = () => import('@/views/pages/main-pages/add-new-baby/AddNewBaby.vue')
const SettingUserInfoPage = () => import('@/views/pages/main-pages/setting/change-user-info/ChangeUserInfo.vue')

const NotFound = () => import('@/views/pages/error-pages/404/NotFound.vue')
const InternalServerErrorPage = () => import('@/views/pages/error-pages/500/InternalError.vue')

const AtomPage = () => import('@/views/pages/atom-page/AtomPage.vue')


Vue.use(VueRouter)
const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: MainLayout,
    meta: {requiresAuth: true},
    redirect: {name: 'routes.home'},
    children: [
      {
        path: 'home',
        name: 'routes.home',
        component: HomePage,
        meta: {requiresAuth: true}
      },
      {
        path: '/baby/:id/grow-tree',
        name: 'routes.growTree',
        component: GrowTreePage,
        meta: {requiresAuth: true}
      },
      {
        path: '/baby/:id/album',
        name: 'routes.album',
        component: AlbumPage,
        meta: {requiresAuth: true}
      },
      {
        path: 'search',
        name: 'routes.search',
        component: SearchInputPage,
        meta: {requiresAuth: true, backToPreviousEnable: true}
      },
      {
        path: '/search/result/baby/:id',
        name: 'routes.search.result',
        component: SearchResultPage,
        meta: {requiresAuth: true, backToPreviousEnable: true}
      },
      // {
      //   path: 'setting',
      //   name: 'routes.setting',
      //   component: SettingPage,
      //   meta: {requiresAuth: true}
      // },
      {
        path: 'change/user/info',
        name: 'routes.change.user.info',
        component: SettingUserInfoPage,
        meta: {requiresAuth: true}
      },
      {
        path: 'add/new-baby',
        name: 'routes.new.baby',
        component: AddNewBaby,
        meta: {requiresAuth: true}
      },
    ]
  },
  {
    path: '/auth',
    name: 'routes.auth',
    component: AuthLayout,
    redirect: {name: 'routes.auth.login'},
    children: [
      {
        path: '/auth/login',
        name: 'routes.auth.login',
        component: LoginPage,
        meta: {requiresAuth: false},
        beforeEnter: (to, from, next) => {
          next();
          LoadImage()
        }
      },
      {
        path: '/auth/register',
        name: 'routes.auth.register',
        component: RegisterPage,
        meta: {requiresAuth: false, showButtonControl: true}
      },
      {
        path: '/auth/forgot-password',
        name: 'routes.auth.forgotPassword',
        component: ForgotPasswordPage,
        meta: {requiresAuth: false}
      },
      {
        path: '/auth/change-password',
        name: 'routes.auth.changePassword',
        component: ChangePasswordPage,
        meta: {requiresAuth: false}
      },
      {
        path: '/auth/reset-password-success',
        name: 'routes.auth.resetPasswordSuccess',
        component: ResetPasswordSuccessPage,
        meta: {requiresAuth: false}
      },
      {
        path: '/baby/:id/tutorial',
        name: 'routes.tutorial',
        component: TutorialPage,
        meta: {requiresAuth: true}
      },
      {
        path: '/baby/:id/tutorial/start',
        name: 'routes.tutorial.start',
        component: TutorialStartPage,
        meta: {requiresAuth: true}
      },
      {
        path: '/tutorial/finish',
        name: 'routes.tutorial.finish',
        component: TutorialFinishPage,
        meta: {requiresAuth: true}
      },
    ]
  },
  {
    path: '/components',
    name: 'routes.components',
    component: MainLayout,
    children: [
      {
        path: '/components/atoms',
        name: 'routes.components.atom',
        component: AtomPage
      },
    ]
  },

  {
    path: '/*',
    component: ErrorLayout,
    name: 'routes.error',
    meta: {requiresAuth: false},
    redirect: { name: 'routes.error.notFound' },
    children: [
      {
        path: '/404',
        name: 'routes.error.notFound',
        component: NotFound,
        meta: {requiresAuth: false}
      },
      {
        path: '/505',
        name: 'routes.error.internalServerError',
        component: InternalServerErrorPage,
        meta: {requiresAuth: false}
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


import VueCookies from "vue-cookies"
import {COOKIES} from "@/constants";
import ErrorLayout from "@/views/layout/error/ErrorLayout.vue";
import {LoadImage} from "@/utils/load-imags.util";
router.beforeEach((to: any, from, next) => {
  const accessToken = (VueCookies as any).get(COOKIES.accessToken)

  if (!to.meta.requiresAuth) {
    if (to.name !== 'routes.auth.login') return next()
    if (to.name === 'routes.auth.login' && accessToken) return next({name: 'routes.home'})
  }

  if (to.meta.requiresAuth && accessToken) return next()
  if (to.name === 'routes.auth.login') return next()

  return next({name: 'routes.auth.login'})
})

export default router
